export * from './map.component';
